import {
    formatAMPM
} from './common.js';

// require('./counter');
$(() => {
    let locale = ($('html').attr('lang')).trim();
    let lang = require(`./lang/memory/${locale}.json`);

    let resultCounter = localStorage.getItem('memory_result_counter') ?? 0;
    localStorage.setItem('memory_result_counter', resultCounter);

    function resetTable() {
        $('#memory-results-head').html(`<tr class="text-muted text-center small">
            <th scope="col">${lang.no_results}</th>
        </tr>`);

        $('#memory-results-body').html('');

        $('#clear-memory-results').attr('disabled', true);
    }

    function insertTableHeader() {
        $('#memory-results-head').html(`<tr class="text-muted small">
            <th scope="col">${lang.number}</th>
            <th scope="col" class="text-center">${lang.category}</th>
            <th scope="col" class="text-center">${lang.time}</th>
            <th scope="col" class="text-end">${lang.date}</th>
        </tr>`);

        $('#clear-memory-results').attr('disabled', false);
    }

    function appendResult(result) {
        $('#memory-results-body').append(`
            <tr class="small">
                <td>${result.number}.</td>
                <td class="text-center"><span class="fw-bold text-capitalize">${result.category}</span></td>
                <td class="text-center">${result.time}</td>
                <td class="text-end">${result.date}</td>
            </tr>`);
    }

    if (resultCounter > 0) {
        insertTableHeader();

        for (let i = 1; i <= resultCounter; i++) {
            let result = JSON.parse(localStorage.getItem(`memory_result_${i}`));

            if (result) {
                appendResult(result);
            }
        }
    } else {
        resetTable();
    }

    $('#clear-memory-results').on('click', function(e) {
        for (let i = 1; i <= resultCounter; i++) {
            localStorage.removeItem(`memory_result_${i}`);
        }
        resultCounter = 0;
        localStorage.setItem('memory_result_counter', resultCounter);
        resetTable();
    });

    $('.select-category').on('click', function(e) {
        let $this = $(this);
        // let category = ($this.attr('data-category')).trim();
        let category = ($this.text()).trim();

        localStorage.setItem('category', category);
        location.reload();
    });

    let categories = ['animals', 'birds', 'cars', 'colors', 'crowns', 'flags', 'fruits', 'numbers', 'school', 'space'];

    if (locale == 'ar') {
        categories = ['حيوانات', 'طيور', 'سيارات', 'ألوان', 'تيجان', 'أعلام', 'فواكه', 'أرقام', 'مدرسة', 'فضاء'];
    };

    let categoryNumber;

    $('#category-count').text(categories.length);

    // returns a random item from an array
    let getRandomItem = arr => {
        let randomNumber = Math.floor(Math.random() * arr.length);
        let item = arr[randomNumber];
        categoryNumber = randomNumber;
        return item;
    };

    if (!localStorage.getItem('category')) {
        $('.get-random-category')
            .removeClass('text-muted')
            .addClass('text-primary fw-bold');
    } else {
        $('.get-random-category')
            .removeClass('text-primary fw-bold')
            .addClass('text-muted');
    };

    let category = localStorage.getItem('category') ?? getRandomItem(categories);

    if (categoryNumber == undefined) {
        categoryNumber = categories.indexOf(category.toLowerCase());
    }

    let categoryUpperCaseFirst = category.charAt(0).toUpperCase() + category.slice(1);

    let selectedCategory = $(`.select-category:contains(${categoryUpperCaseFirst})`).addClass('bg-primary text-light');

    // $('#category').val(category.toUpperCase());
    $('#category').text(category);

    let handleZero = val => {
        val = val + '';
        if (val.length < 2) {
            return '0' + val;
        }
        return val;
    };

    let minutesSelector = $('#minutes');
    let secondsSelector = $('#seconds');

    let totalSeconds = 0;

    let startTimer = () => {
        ++totalSeconds;
        let secondsCount = handleZero(totalSeconds % 60);
        let minutesCount = handleZero(parseInt(totalSeconds / 60));

        secondsSelector.html(secondsCount);
        minutesSelector.html(minutesCount);

        if (parseInt(minutesCount) == 58) {
            showToast({
                type: 'warning',
                title: lang.resetting,
                message: lang.reset
            })
        } else if (parseInt(secondsCount) == 0 && parseInt(minutesCount) == 60) {
            location.reload();
        };
    };

    let timer;

    let stopTimer = () => {
        clearInterval(timer);
    };

    let record = [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0
    ]; // all are 0 (default) = not flipped. When a card is flipped, value is 1

    let flipIndex = 0; // count number of cards flipped
    let cardTextRec = []; // holds img syntax
    let cardRec = []; // holds card numbers; needed for flipping cards back
    let cardNum;
    let cardChk = 0;
    let correct = 0;

    let front;
    let back;

    const memory = $('#game');
    const scoreEl = $('#score');

    let countDown;
    let secsInput = 60;
    let seconds = secsInput;

    let gameOver = false;

    let showToast = alert => {
        let html = `<div class="toast-container position-fixed bottom-0 end-0 p-3">
                <div id="resultToast" class="toast text-bg-${alert.type}" role="alert" aria-live="assertive" aria-atomic="true" data-bs-autohide="false">
                    <div class="toast-header">
                        <strong class="me-auto">${alert.title}</strong>
                        <!--<small>...</small>-->
                        <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="${lang.close}"></button>
                    </div>
                    <div class="toast-body">${alert.message}</div>
                </div>
            </div>`;

        $('#alert').html(html);

        $('body').find('#resultToast').toast('show');
    };

    let successPhrases = [lang.great, lang.well_done, lang.good_job, lang.you_made_it, lang.wow, lang.fantastic];

    let displayResults = () => {
        gameOver = true;

        if (correct == 10) {
            let minutes = $('#minutes').text();
            let seconds = $('#seconds').text();

            stopTimer();

            $('#timer').addClass(['font-weight-bold', 'text-success']);

            showToast({
                'type': 'success',
                'title': successPhrases[Math.floor(Math.random() * successPhrases.length)],
                'message': lang.game_over_message
            });

            resultCounter++;
            localStorage.setItem('memory_result_counter', resultCounter);

            let thisDate = new Date();

            let year = thisDate.getFullYear();
            let month = thisDate.getMonth() + 1;
            let day = thisDate.getDate();

            // Update Results
            let result = {
                number: resultCounter,
                category: category,
                time: `${minutes}:${seconds}`,
                date: `${month}/${day}/${year} - ${formatAMPM(thisDate)}`
            };

            if (resultCounter == 1) {
                insertTableHeader();
            }

            appendResult(result);

            localStorage.setItem(`memory_result_${resultCounter}`, JSON.stringify(result));
        } else {
            showToast({
                'type': 'danger',
                'title': lang.try_again,
                'message': lang.your_score + ' ' + correct + '.'
            });
        }
    };

    let flipBack = () => {
        front = $(`.front[id="front-${cardRec[0]}"]`);
        back = $(`.back[id="back-${cardRec[0]}"]`);

        front.css('transform', 'rotateY(0deg)');
        back.css('transform', 'rotateY(180deg)');

        front = $(`.front[id="front-${cardRec[1]}"]`);
        back = $(`.back[id="back-${cardRec[1]}"]`);

        front.css('transform', 'rotateY(0deg)');
        back.css('transform', 'rotateY(180deg)');

        // reset record for cards to 0 (i.e., not flipped)
        record[cardRec[0] - 1] = 0;
        record[cardRec[1] - 1] = 0;

        // empty arrays
        cardTextRec = []; // holds img syntax
        cardRec = []; // holds card numbers

        flipIndex = 0; // reset counter to allow more cards to be checked

        cardChk = 0; // done
    };

    let clickCard = cardId => {
        // check if game is over
        // check if record value of the card is 0
        // check if card is checked/flipped

        let cardOrderInArray = cardId - 1; // start from 0

        if (record[cardOrderInArray] == 0 &&
                cardChk == 0 &&
                !gameOver) {
            // flip
            front = $(`.front[id="front-${cardId}"]`);
            back = $(`.back[id="back-${cardId}"]`);

            front.css('transform', 'rotateY(-180deg)');
            back.css('transform', 'rotateY(0deg)');

            // add img to array
            cardTextRec.push(back.html());

            // add card number to array
            cardRec.push(cardId);

            // increment flip count
            flipIndex++;

            record[cardId - 1] = 1; // card is flipped

            // if flipIndex == 2, 2 cards have been flipped. So, compare
            if (flipIndex == 2) {
                // compare if the img strings are equal
                if (cardTextRec[0] === cardTextRec[1]) { // success, the two images are identical
                    correct++; // add one score
                    scoreEl.html(correct); // text in view

                    // empty arrays
                    cardTextRec = []; // holds img syntax
                    cardRec = []; // holds card numbers

                    flipIndex = 0; // reset counter to allow more cards to be checked

                    // when done!!!
                    if (correct == 10) {
                        // show results and stop game; delay to allow flipping (see CSS)
                        setTimeout(() => {
                            displayResults();
                        }, 600); // .6 sec; higher than .5 sec
                    };

                    return;
                } else { // cards are not equal; wrong attempt
                    // flip both cards back
                    cardChk = 1; // prevent user from clicking more cards before flipping takes place
                    // flip back after .6 sec
                    setTimeout(() => {
                        flipBack();
                    }, 600);

                    return;
                }
            }
        }

        if (gameOver) {
            showToast({
                'type': 'info',
                'title': lang.game_over,
                'message': lang.your_score + ' ' + correct + '.'
            });
        }
    };

    let clickCounts = 0;

    $('.cards').on('click', function(e) {
        clickCounts++;
        let cardId = parseInt($(this).attr('data-card-id'));

        if (clickCounts === 1) {
            $('#timer-icon')
                .removeClass('text-muted bi-stopwatch')
                .addClass('text-danger bi-stopwatch-fill');
            $('#timer').removeClass('text-muted');
            timer = setInterval(startTimer, 1000);
        }

        clickCard(cardId);
    });

    let images = [
        `<img src="../img/memory/${categoryNumber}/1.svg">`,
        `<img src="../img/memory/${categoryNumber}/2.svg">`,
        `<img src="../img/memory/${categoryNumber}/3.svg">`,
        `<img src="../img/memory/${categoryNumber}/4.svg">`,
        `<img src="../img/memory/${categoryNumber}/5.svg">`,
        `<img src="../img/memory/${categoryNumber}/6.svg">`,
        `<img src="../img/memory/${categoryNumber}/7.svg">`,
        `<img src="../img/memory/${categoryNumber}/8.svg">`,
        `<img src="../img/memory/${categoryNumber}/9.svg">`,
        `<img src="../img/memory/${categoryNumber}/10.svg">`,

        `<img src="../img/memory/${categoryNumber}/1.svg">`,
        `<img src="../img/memory/${categoryNumber}/2.svg">`,
        `<img src="../img/memory/${categoryNumber}/3.svg">`,
        `<img src="../img/memory/${categoryNumber}/4.svg">`,
        `<img src="../img/memory/${categoryNumber}/5.svg">`,
        `<img src="../img/memory/${categoryNumber}/6.svg">`,
        `<img src="../img/memory/${categoryNumber}/7.svg">`,
        `<img src="../img/memory/${categoryNumber}/8.svg">`,
        `<img src="../img/memory/${categoryNumber}/9.svg">`,
        `<img src="../img/memory/${categoryNumber}/10.svg">`
    ];

    let imgRec = []; // to hold indexes of the images array
    let rand; // holds random numbers

    let status = 0; // 0 means rand is unique

    let makeRandomNumber = () => {
        return Math.round(Math.random() * images.length);
    }

    // randomize images
    let newBoard = () => {
        let i;
        for (i = 0; i < 20; i++) {
            // first round, pick any image
            if (i === 0) {
                rand = makeRandomNumber();

                // we don't want 20 to be generated because the images array won't accept it
                if (rand == 20) {
                    rand = rand - 1;
                }

                // update image record
                imgRec[i] = rand; // index number of image tag
            } else { // rest of images
                // generate unique indexes not in imgRec array
                while (status === 0) {
                    rand = makeRandomNumber();

                    if (rand !== images.length) { // not 20
                        // check if rand is already in picked (in imgRec)
                        let x;
                        for (x = 0; x < imgRec.length; x++) {
                            if (rand === imgRec[x]) {
                                break; // stop when found
                            } else if (x == imgRec.length - 1) { // unique rand; no need for elseif -- else is good
                                status = 1; // to stop while

                                // insert index
                                imgRec[i] = rand;
                            } // end if
                        } // end for
                    } // end if
                } // end while
            } // end else
            status = 0; // to generate another random number for the next img

            $(`#back-${i + 1}`).html(images[rand]);

        } // end of for
    };

    newBoard();

    // create a function to pick a random index number from an array
    // the argument is array

    // new game; simply refresh page
    $('body').on('click', '.get-random-category', function(e) {
        localStorage.removeItem('category');
        location.reload();
    });

    $('body').on('click', '.shuffle-images', function(e) {
        let category = ($('#category').text()).trim();

        localStorage.setItem('category', category);

        location.reload();
    });

    $('#show-memory-images').on('click', function(e) {
        $('#memory-images').html('');
        let i;
        let imageRow;
        let title;
        let desc;

        // let foundImageIcon = `<sup class="bi bi-check-circle-fill ms-2 small text-success"></sup>`;

        for (i = 1; i < 11; i++) {
            title = `${categoryNumber}_${i}_title`;
            desc = `${categoryNumber}_${i}_desc`;
            imageRow = `<div class="row g-0">
                <div class="col-md-4 text-center">
                    <img src="../img/memory/${categoryNumber}/${i}.svg" width="80" alt="...">
                </div>
                <div class="col-md-8">
                    <h6 class="card-title">${lang[title]}</h6>
                    <!--<p class="card-text">${lang[desc]}</p>-->
                </div>
            </div>`;

            if (i < 10) {
                imageRow += `<hr>`;
            }

            $('#memory-images').append(imageRow);
        }

        $('#memoryImagesModalLabel').text(categoryUpperCaseFirst);

        $('#memoryImagesModal').modal('show');
    });

});
